// extracted by mini-css-extract-plugin
export default {"container":"TitleSubtitle_container__ON6cD","title":"TitleSubtitle_title__GVzXS","subtitle":"TitleSubtitle_subtitle__XhLJx"};